import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Container, Row, Col, Card, CardBody, Modal, Alert, FormGroup, Label, Input } from 'reactstrap';
import { MDBDataTable } from 'mdbreact';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import Breadcrumbs from '../../../components/Common/Breadcrumb';
import api from '../../../api';
import moment from 'moment';
moment.locale('tr');

const Transfers = () => {
	const [transfers, setTransfers] = useState([]);

	function fetchContents() {
		api.content.transfer.all().then((res) => {
			let data = [];

			if (res.success) {
				res?.transfers?.map((item) => {
					data.push({
						...item,
						name: item.player.name,
						currentTeam: item.teams.current.name,
						outgoingTeam: item.teams.new.name,
						date: moment(item.createdAt).format('DD-MM-YYYY HH:mm'),
						editor: item.name,
						verified: item.verification ? 'Doğrulandı' : 'Doğrulanmadı',
						content: (
							<a href={`/news/news/${item.content.ContentId}`} className="btn btn-primary" rel="noreferrer" target="_blank">
								Yönet
							</a>
						),
						settings: (
							<div className="btn-group mr-2">
								<button className="btn btn-secondary" onClick={() => editContent(item.id, item.status, item.verification, item.source)}>
									<i className="bx bxs-pencil"></i>
								</button>
								<button
									className={`btn ${!item.isActive ? 'btn-danger' : 'btn-secondary'}`}
									onClick={() => {
										if (!item.isActive) {
											window.confirm('Geri almak istediğinize emin misiniz?') && deleteContent(item.id, item.status, item.source, true);
										} else {
											window.confirm('Silmek istediğinize emin misiniz?') && deleteContent(item.id, item.status, item.source, false);
										}
									}}
								>
									<i className="bx bx-trash"></i>
								</button>
							</div>
						),
					});
				});

				setTransfers(data);
			}
		});
	}

	useEffect(() => {
		fetchContents();
	}, []);

	const [editStatus, setEditStatus] = React.useState(false);
	const [contentId, setContentId] = React.useState(0);
	const [contentStatus, setContentStatus] = React.useState(null);
	const [contentSource, setContentSource] = React.useState(null);
	const [contentVerified, setContentVerified] = React.useState(null);
	const [alert, setAlert] = React.useState({ success: false, message: '' });
	const [loading, setLoading] = React.useState(false);

	const editContent = (id, status, verification, source) => {
		setEditStatus(true);
		setContentId(id);
		setContentStatus(status);
		setContentVerified(verification);
		setContentSource(source);
	};

	const data = {
		columns: [
			{
				label: 'Oyuncu',
				field: 'name',
				sort: 'asc',
				width: '200px',
			},
			{
				label: 'Geldiği Takım',
				field: 'currentTeam',
				sort: 'asc',
				width: '200px',
			},
			{
				label: 'Gittiği Takım',
				field: 'outgoingTeam',
				sort: 'asc',
				width: '100px',
			},
			{
				label: 'Bonservis',
				field: 'fee',
				sort: 'asc',
				width: '100px',
			},
			{
				label: 'Kaynak',
				field: 'source',
				sort: 'asc',
				width: '100px',
			},
			{
				label: 'Durumu',
				field: 'status',
				sort: 'asc',
				width: '100px',
			},
			{
				label: 'Doğrulanma Durumu',
				field: 'verified',
				sort: 'asc',
				width: '100px',
			},
			{
				label: 'İlgili Haber',
				field: 'content',
				sort: 'asc',
				width: '100px',
			},
			{
				label: '#',
				field: 'settings',
				sort: 'asc',
				width: 50,
			},
		],
		rows: transfers,
	};

	function update(id) {
		setLoading(true);

		setAlert({ success: false, message: '' });

		const data = {
			id,
			status: contentStatus,
			source: contentSource,
			verification: contentVerified,
		};

		api.content.transfer.update(data).then((res) => {
			setLoading(false);
			setAlert({ success: res.success, message: res.message });

			if (res.success) {
				fetchContents();
				setContentId(0);
				setContentStatus(null);
				setContentSource(null);
				setContentVerified(null);

				setTimeout(() => {
					setEditStatus(false);
					setAlert({ success: false, message: '' });
				}, 1000);
			}
		});
	}

	function deleteContent(id, status, source, isActive) {
		api.content.transfer.update({ id, status, source, isActive }).then((res) => {
			if (res.success) {
				toastr.options = {
					positionClass: 'toast-top-center',
					progressBar: true,
				};
				toastr.success(res.message);
				fetchContents();
			} else {
				toastr.options = {
					positionClass: 'toast-top-center',
					progressBar: true,
				};
				toastr.error(res.message);
			}
		});
	}

	return (
		<>
			<Helmet>
				<title>{`Transfer Haberleri | ${process.env.REACT_APP_TITLE}`}</title>
			</Helmet>
			<div className="page-content">
				<Container fluid>
					<Breadcrumbs title="Haber Yönetimi" breadcrumbItem="Manşetler" />

					<Row>
						<Col xs="12">
							<div className="mb-3">
								<Card>
									<CardBody>
										<a href="/news/transfer/add" className="btn btn-primary">
											Yeni Transfer Ekle
										</a>

										<div className="mini-table">
											<MDBDataTable
												responsive
												striped
												bordered
												data={data}
												noRecordsFoundLabel="Hiçbir kayıt bulunamadı"
												paginationLabel={['Önceki', 'Sonraki']}
												entriesLabel="Göster"
												infoLabel={['Gösterilen', '-', ', toplam', 'kayıt']}
												searchLabel="Ara"
											/>
										</div>
									</CardBody>
								</Card>
							</div>
						</Col>
					</Row>
				</Container>
			</div>

			<Modal
				isOpen={editStatus}
				toggle={() => {
					setEditStatus(!editStatus);
					setContentId(0);
					setContentStatus(null);
					setContentSource(null);
					setContentVerified(null);
				}}
				centered={true}
			>
				<div className="modal-header">
					<h5 className="modal-title mt-0">Haberi düzenleyin.</h5>
					<button
						type="button"
						onClick={() => {
							setEditStatus(false);
							setContentId(0);
							setContentStatus(null);
							setContentSource(null);
							setContentVerified(null);
						}}
						className="close"
						data-dismiss="modal"
						aria-label="Kapat"
					>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div className="modal-body">
					{alert.message !== '' && <Alert color={alert.success ? 'success' : 'danger'}>{alert.message}</Alert>}

					<FormGroup>
						<Label>Kaynak (*)</Label>
						<Input name="source" value={contentSource} onChange={(e) => setContentSource(e.target.value)} />
					</FormGroup>

					<FormGroup>
						<Label>Durumu (*)</Label>
						<Input name="status" value={contentStatus} onChange={(e) => setContentStatus(e.target.value)} />
					</FormGroup>

					<div className="form-group">
						<label htmlFor="name">Transfer Doğrulandı mı?</label>
						<div className="d-flex flex-row">
							<div className="custom-control custom-radio mr-3">
								<input type="radio" id="content-verified" name="customRadio" className="custom-control-input" onChange={() => setContentVerified(true)} checked={contentVerified} />
								<label className="custom-control-label" htmlFor="content-verified">
									Evet
								</label>
							</div>
							<div className="custom-control custom-radio">
								<input type="radio" id="gecontent-verified" name="customRadio" className="custom-control-input" onChange={() => setContentVerified(false)} checked={!contentVerified} />
								<label className="custom-control-label" htmlFor="gecontent-verified">
									Hayır
								</label>
							</div>
						</div>
					</div>

					<button className="btn btn-info mt-4" onClick={() => (!loading ? update(contentId) : null)}>
						{loading ? <i className="bx bx-loader bx-spin"></i> : 'Düzenle'}
					</button>
				</div>
			</Modal>
		</>
	);
};

export default Transfers;
